/* eslint-disable @typescript-eslint/naming-convention */
import { useComputed } from '@preact/signals-react'

import Icon from '../../../components/Icon.jsx'
import SelectParentBusinessEntityLeaves from './SelectParentBusinessEntityLeaves.jsx'

import { debugSignal } from '../../../state/signals/userSettingsSignals.js'

import { iconForOrgType } from '../../../utils/utils.js'

const SelectParentBusinessEntityLeaf = function ({ businessEntity, type, selectedBusinessEntityIdSignal, selectedBusinessEntityIdsSignal, enableSubmitSignal, depth }) {

	const debug = debugSignal.value && false
	const id = businessEntity.id

	const checkedComputed = useComputed(
		() => {
			if (type == "radio") {
				return selectedBusinessEntityIdSignal.value == businessEntity.id
			} else if (type == "checkbox") {
				return selectedBusinessEntityIdsSignal.value.has(businessEntity.id)
			}
		}
	)

	const check = () => {
		if (type == "radio") {
			selectedBusinessEntityIdSignal.value = businessEntity.id
		} else if (type == "checkbox") {
			const next = new Set(selectedBusinessEntityIdsSignal.value)
			if (next.has(businessEntity.id)) {
				next.delete(businessEntity.id)
			} else {
				next.add(businessEntity.id)
			}
			selectedBusinessEntityIdsSignal.value = next
			if (enableSubmitSignal) {
				enableSubmitSignal.value = next.size > 0
			}
		}
	}

	return (
		<>
			<tr className="selectParentBELeaf" key={id}>
				<td style={{ paddingLeft: (depth * 30).toString().concat('px') }}>
					<Icon icon={iconForOrgType(businessEntity)} height={16} width={16}></Icon>
					&nbsp;{businessEntity.name}
				</td>
				<td className='checkbox-icon'>
					{debug && (<>{id}&nbsp;</>)}
					<label hidden={checkedComputed.value} onClick={check}>
						<Icon style={{ fontSize: "28px", color: "#ccc" }} icon={type == "radio" ? "check-circle" : "check-square"}></Icon>{debug && (<>&nbsp;Off</>)}
					</label>
					<label hidden={!checkedComputed.value} onClick={check}>
						<Icon style={{ fontSize: "28px", color: "#6f2a8e" }} icon={type == "radio" ? "check-circle-fill" : "check-square-fill"}></Icon>{debug && (<>&nbsp;On</>)}
					</label>
				</td>
			</tr>
			{
				(businessEntity.companies.length > 0) ? (
					<SelectParentBusinessEntityLeaves
						businessEntities={businessEntity.companies}
						type={type}
						selectedBusinessEntityIdSignal={selectedBusinessEntityIdSignal}
						selectedBusinessEntityIdsSignal={selectedBusinessEntityIdsSignal}
						enableSubmitSignal={enableSubmitSignal}
						depth={depth + 1}
					></SelectParentBusinessEntityLeaves>
				) : (<></>)
			}
		</>
	)
}
export default SelectParentBusinessEntityLeaf